var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup3216(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.954,
    height: 100,
    viewBox: "0 0 99.954 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3216",
    "data-name": "Group 3216",
    transform: "translate(655.226 -189.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4698",
    "data-name": "Path 4698",
    d: "M-614.422,271.13a40.825,40.825,0,0,1-40.8-41.281c.1-22.384,18.6-40.534,41.217-40.438a40.846,40.846,0,0,1,40.5,40.911A40.779,40.779,0,0,1-614.422,271.13ZM-650.5,230.261a36.18,36.18,0,0,0,35.928,36.128,36.075,36.075,0,0,0,36.32-35.923,36.158,36.158,0,0,0-36.062-36.33A36.247,36.247,0,0,0-650.5,230.261Z",
    transform: "translate(0 0)",
    fill: "#6b344a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4699",
    "data-name": "Path 4699",
    d: "M-326.372,507.169c0,5.066-2.358,8.72-6.154,10.258a9.484,9.484,0,0,1-10.818-2c-5.507-5.319-10.877-10.781-16.3-16.191a2.43,2.43,0,0,1-.305-3.553,2.417,2.417,0,0,1,3.642.177c5.353,5.319,10.681,10.663,16.041,15.976a5.3,5.3,0,0,0,8.516-1.147,5.2,5.2,0,0,0-1.08-6.416q-7.034-7.082-14.106-14.125c-.657-.658-1.331-1.3-1.966-1.978a2.389,2.389,0,0,1-.053-3.481,2.375,2.375,0,0,1,3.4.122q8.29,8.27,16.534,16.586A8.986,8.986,0,0,1-326.372,507.169Z",
    transform: "translate(-228.899 -228.883)",
    fill: "#6b344a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4700",
    "data-name": "Path 4700",
    d: "M-551.637,245.019A13.682,13.682,0,0,1-537.3,256.3a23.971,23.971,0,0,1-6.046,20.542,4.889,4.889,0,0,0-1,1.983,1.368,1.368,0,0,0,1.048,1.72,58.934,58.934,0,0,0,6.177,1.751,8.2,8.2,0,0,1,6.973,6.32c.469,1.715.867,3.45,1.276,5.181a2.315,2.315,0,0,1-1.719,2.907,2.284,2.284,0,0,1-2.834-1.677c-.492-1.747-.907-3.516-1.344-5.278a3.573,3.573,0,0,0-2.99-2.747,68.057,68.057,0,0,1-7.447-2.142c-4.749-1.736-4.921-8.034-2.127-10.776a17.623,17.623,0,0,0,5.289-10.55c.3-2.338.642-4.715-.051-7.076a9.382,9.382,0,0,0-8.848-6.721c-3.567-.11-6.607.8-8.83,3.737a8.68,8.68,0,0,0-1.808,4.935c-.283,6.107,1.316,11.521,5.752,15.931,2.464,2.45,2.68,8.8-2.336,10.539-2.475.86-5.031,1.5-7.57,2.156a3.418,3.418,0,0,0-2.794,2.536q-.64,2.532-1.279,5.063c-.4,1.58-1.57,2.443-2.874,2.128a2.425,2.425,0,0,1-1.768-3.2c.42-1.8.834-3.614,1.368-5.387a8.1,8.1,0,0,1,6.533-5.824c2.09-.465,4.158-1.059,6.2-1.72,1.669-.541,1.973-2.08.743-3.364a22.737,22.737,0,0,1-5.8-10.131c-1.037-4.027-1.524-8.125-.346-12.2A13.905,13.905,0,0,1-551.637,245.019Z",
    transform: "translate(-62.675 -43.186)",
    fill: "#6b344a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3216);
export default __webpack_public_path__ + "static/media/Group 3216.509040a14c9e931c65b96dbc0ab116ca.svg";
export { ForwardRef as ReactComponent };